import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { FormInput } from '../../components/FormInput';
import { useTranslation } from 'react-i18next';
import PrimeTableFooter from '../../components/PrimeTableFooter';
import NoInfo from '../../components/NoInfo';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { checkDpSuccess, getMaskedString } from '../../utility/service/tool-service';
import { queryInviteRecordsList, updateInviteRecords } from '../../utility/service/invite-service';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import { getSubItemsByItemNo } from '../../utility/service/api-service';
import PrimeConfirmDialog from '../../components/dialog/PrimeConfirmDialog';
import { useFuncId } from '../../router/menuRouterMapper';
import { updateAuditEyesEvent } from '../../utility/service/audilog-service';
import { useEditableFlag } from '../../hooks/useEditableFlag';

const InviteRecord_Index = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [,loading] = useContext(SystemLoading);
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [rows,setRows] = useState([]);
    const [inviteSeq,setInviteSeq] = useState('');
    const [inviteStatusList,setInviteStatusList] = useState([]);
    const [delDialog,setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState({});
    const [statusList,setStatusList] = useState([]);
    const [maskView,setMaskView] = useState(false);
    const chsFuncId = useFuncId();
    const isEditable = useEditableFlag('B10102'); // Get editable status for B10102 function
    
    const esgClientId = [
        {
            label:t('company.a'),
            value:'A'
        },
        {
            label:t('company.b'),
            value:'B'
        }
    ]

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            keywordSearch:''
        },
        //錯誤驗證時機
        mode: "all"
      });

    const onSubmit = (data)=>{
        let reqBody = {
          keywordSearch:data.keywordSearch,
        }
        if(data.inviteStatus!==null && data.inviteStatus!=='' && data.inviteStatus!==undefined){
            reqBody.inviteStatus = data.inviteStatus
        }
        axios_queryInviteRecordsList(reqBody);
        
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const addNewInvite = ()=>{
      setAction('create');
      navigate('create')
    }

     //查詢更多
    const btnReadMore = () => {
      let reqBody = {
        keywordSearch:getValues("keywordSearch"),
        inviteSeq:inviteSeq
      }
      let STATUS = getValues("inviteStatus");
      if(STATUS!==null && STATUS!=='' && STATUS!==undefined){
          reqBody.inviteStatus = STATUS
      }
      axios_queryInviteRecordsList(reqBody,true);
    };

    const statusBodyTemplate = (rowData, props)=>{
        if(rowData?.companyStatus){
            return (
            <>
              <span className={`p-tag p-tag-${rowData?.companyStatus==='0'?'success':'danger'}`}>{rowData?.companyStatus!=="D"? rowData?.companyStatusName : t("deactivate")}</span> 
            </>)
        }
    } 

    const typeBodyTemplate = (rowData, props)=>{
      if(rowData){
          return (
          <>
            {getLabelByValue(rowData?.type)}
          </>)
      }
  } 

  const getLabelByValue=(value) =>{
    const item = esgClientId?.find(item => item.value === value);
    return item ? item.label : null;
}

const getStatusLabel=(value) =>{
  const item = statusList?.find(item => item.subitemNo === value);
  return item ? item.subitemName : null;
}

    const editItem = (item,act)=>{
      setItemObj(item);
      navigate(act);
      setAction(act);
    }

    const updateItem = (rowData,reqType)=>{ //作廢D 或 重發R
      setAction(reqType)
      setDelDialog(true);
      setDelObj(rowData);
    }

    const confirmDel = ()=>{
      updateInviteRecords({
        inviteSeq:delObj?.inviteSeq,
        reqType:action
      })
      .then((res)=>{
        if(checkDpSuccess(res)){
          console.log(res);
          setDelDialog(false);
          let reqBody = {
            keywordSearch:getValues("keywordSearch"),
          }
          let STATUS = getValues("inviteStatus");
          if(STATUS!==null && STATUS!=='' && STATUS!==undefined){
              reqBody.inviteStatus = STATUS
          }
          axios_queryInviteRecordsList(reqBody);
          
        }
      })
    }

    useEffect(()=>{
      axios_getCompanyStatusList();
      axios_getInviteStatusList();
      axios_queryInviteRecordsList({
        keywordSearch:getValues("keywordSearch")
        });
    },[])

    const axios_queryInviteRecordsList = (reqBody,readMore=false)=>{
      checkLoading(loading);
        queryInviteRecordsList(reqBody)
        .then((res)=>{
          if(checkDpSuccess(res)){
              let data = res?.data?.RespBody?.inviteRecordsList;
              if(data?.length > 0){
                setInviteSeq(data[data?.length-1].inviteSeq);
                  if(readMore===true){
                    setRows((pre)=>{
                      return [...pre,...data] 
                    })
                  }else{
                    setRows((pre)=>{
                      return [...data]
                    });
                  }
                }else{
                  if(readMore===false){
                    setRows([]);
                  }
                }
              
          }else{
              if(readMore===false){
                setRows([]);
              }
            }
      }).finally((fin)=>{checkLoading(loading,false);})
  }

  const axios_getInviteStatusList = ()=>{
    getSubItemsByItemNo('INVITE_STATUS',21)
    .then((res)=>{
        if(checkDpSuccess(res)){
            let data = res.data.RespBody.subItems;
            let newArray = data.map((item, index) => {
              return {
                ...item,
                index: index,
              }
            })
            setInviteStatusList(newArray);
        }
    })
  }

    const actionBodyTemplate = (rowData, props) => {
        if (rowData) {
          return (
            <>
               
                <Button tooltip={t('button.detail')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { editItem(rowData,"detail") }}>
                  <FontAwesomeIcon icon="fa-solid fa-eye" />
                </Button>
                <Button disabled={rowData?.inviteStatus==='1' || rowData?.inviteStatus==='3' || !isEditable} tooltip={t('cancelled')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { updateItem(rowData,"D") }}>
                  <FontAwesomeIcon icon="fa-solid fa-ban" />
                </Button>
                
                <Button disabled={rowData?.inviteStatus==='1' || rowData?.inviteStatus==='3' || !isEditable} tooltip={t('button.resend')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { updateItem(rowData,"R") }}>
                  <FontAwesomeIcon icon="fa-solid fa-envelope" />
                </Button>
            </>
    
          )
    
        }
      }

      const axios_getCompanyStatusList = ()=>{
        getSubItemsByItemNo('COMPANY_STATUS',23)
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res.data.RespBody.subItems;
                let newArray = data.map((item, index) => {
                  return {
                    ...item,
                    index: index,
                  }
                })
                setStatusList(newArray);
            }
        })
      }

  const masKAccountTemplate = (rowData, props) => {
    if(rowData){
      return (
        <>{!maskView?getMaskedString("account",rowData?.[props?.field]):rowData?.[props?.field]}</>
      )
    }
  }
  
  const axios_updateAuditEyesEvent = ()=>{
      updateAuditEyesEvent({
          functionId:chsFuncId,
          eventType:"V"
      })
      .then((res)=>{
          if(checkDpSuccess(res)){
  
          }
      })
  }

  return (
    <>
    <div className="p-card bg-gray">
        <div className="p-card-body">
            <form className="flex flex-wrap align-items-center col-12" onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                <div className='col-12 lg:col-3'>
                    <label
                        htmlFor="inviteStatus"
                        className="form-label">
                        {t("inviteStatus")}
                    </label>
                <Controller
                    name="inviteStatus"
                    control={control}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            filter
                            showClear
                            optionLabel="subitemName"
                            optionValue="subitemNo"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs_all")}
                            name="inviteStatus"
                            control={control}
                            options={inviteStatusList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />

                </div>
           
            <div className="col-12 lg:col-9">
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                type="text"
                placeholder={``}
                labelClass="control-label"
                enterClick={checkKeyDown}
                labelText={t('keyword')}
                
              />
            </div>
            <div className="col-12 gap-2 flex-all-center">
                <Button disabled={!isValid} type="submit" label={t("button.query")} />
                <Button disabled={!isEditable} type="button" label={t("button.add")} onClick={()=>{addNewInvite();}} />
            </div>


            </form>
        </div>
    </div>
    <div className="" style={{ top: "28px" }}>
      <Button
        type="button"
        icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
        severity="secondary"
        disabled={rows?.length===0}
        onClick={() => {
          setMaskView(prev => {
            if(!prev){
              axios_updateAuditEyesEvent();
            }
            return !prev;
          });
        }}
      />
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            value={rows}
            footer={rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />}
            emptyMessage={<NoInfo panel="table"/>}
            >
                <Column field="inviteStatusName" header={t('inviteStatus')} style={{ minWidth: '120px' }} />
                <Column field="companyName"  header={t('organName')} />
                <Column style={{ minWidth: '100px' }} field="leader"  header={t('companyLeader')} body={masKAccountTemplate} />
                <Column field="email" header={`${t('company.a')} email`} body={masKAccountTemplate} />
                <Column field="type" header={t('type')} body={typeBodyTemplate} style={{ minWidth: '80px' }} />
                <Column field="companyStatus"  header={t('companyStatus')} body={statusBodyTemplate} style={{ minWidth: '100px' }} />
                <Column field="inviteEndDate"  header={t('validityDate')} />
                <Column field="updateUser" header={t('update_user')} style={{ minWidth: '100px' }} />
                <Column style={{ minWidth: '170px' }} body={actionBodyTemplate} header={t('action')} frozen alignFrozen="right" />
            </DataTable>
        </div>

    </div>

 {/* 作廢 重發 */}
 <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => { setDelDialog(false) }}
        onConfirm={() => { confirmDel(); }}
        title={action==='D'?t('cancelled'):t('button.resend')}
        bodyTemplate={<>
        <div>
        {action==='D'?t('cf_cancel_record'):t('cf_resend_record')}
        </div>
        </>}
      />

    </>
    
  )
}

export default InviteRecord_Index